define('presentation/settings/outboundCallingCampaigns/presentationObjects/outboundCallingCampaignPresentationObject',[], function() {
    return function(){
        const self = this;

        self.outboundCallingCampaignId = null;
        self.name = null;
        self.campaignCode = null;
        self.active = false;
        self.canActivate = false;
        self.genesysCampaignId = null;
        self.liveReceptionistScriptId = null;
        self.outboundCallerId = null;
        self.editOutboundCallingCampaignUrl = null;
        self.createdDateTime = null;
        self.updatedDateTime = null;
    };
});

